import type { MutableEmptyObject } from '@enmon/commons';
import { Card } from 'components';
import type { FC } from 'react';

interface MeterModulePdfViewerProps extends MutableEmptyObject {}

export const MeterModulePdfViewer: FC<MeterModulePdfViewerProps> = () => {
  return <Card title="PDF Viewer" />;
};
